import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["metaId", "text", "className", "favBtn"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import { useAddFavoriteMutation, useAuthUserWithFavoritesQuery, useDeleteFavoriteMutation, useNotification } from "@/hooks";
import styles from "@/styles/Button.module.scss";
import classnames from "classnames";
import { useCallback, useEffect, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconFav = function IconFav(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      clipRule: "evenodd",
      fill: "none",
      stroke: "#AAA",
      strokeWidth: "1.24",
      d: "m12.6 7.3 5.9.8-4.3 4.2 1.1 5.9-5.3-2.9-5.3 2.8 1.1-5.8-4.3-4.2 5.9-.8L10 1.8l2.6 5.5z"
    })
  }));
};
IconFav.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  xmlSpace: "preserve"
};
export default function FavoriteButton(props) {
  const {
      metaId,
      text,
      className,
      favBtn
    } = props,
    buttonProps = _objectWithoutProperties(props, _excluded);
  const {
    showNotification
  } = useNotification();
  const {
    0: favoriteOn,
    1: setFavoriteOn
  } = useState(false);
  const [addFavorite] = useAddFavoriteMutation({
    onCompleted: _ref => {
      let {
        addFavorite
      } = _ref;
      if (addFavorite.result) {
        showNotification("お気に入りに登録しました");
        setFavoriteOn(true);
      }
    },
    update: cache => {
      cache.evict({
        fieldName: "favoritesByContentType"
      });
      cache.gc();
    }
  });
  const [deleteFavorite] = useDeleteFavoriteMutation({
    onCompleted: _ref2 => {
      let {
        deleteFavorite
      } = _ref2;
      if (deleteFavorite.result) {
        showNotification("お気に入りから削除しました");
        setFavoriteOn(false);
      }
    },
    update: cache => {
      cache.evict({
        fieldName: "favoritesByContentType"
      });
      cache.gc();
    }
  });
  const {
    data
  } = useAuthUserWithFavoritesQuery({
    fetchPolicy: "cache-first"
  });
  const user = data === null || data === void 0 ? void 0 : data.user;
  const favorites = data === null || data === void 0 ? void 0 : data.favorites;
  const handleClick = useCallback(e => {
    e === null || e === void 0 || e.preventDefault();
    e === null || e === void 0 || e.stopPropagation();
    if (favoriteOn) {
      deleteFavorite({
        variables: {
          id: parseInt(metaId, 10)
        }
      });
    } else {
      addFavorite({
        variables: {
          id: parseInt(metaId, 10)
        }
      });
    }
  }, [favoriteOn]);
  useEffect(() => {
    let mounted = true;
    if (user) {
      const fav = !!favorites.metas.find(meta => (meta === null || meta === void 0 ? void 0 : meta.id) === metaId);
      if (mounted) {
        setFavoriteOn(fav);
      }
    }
    return () => {
      mounted = false;
    };
  }, [user, favorites]);
  if (!user) return null;
  return /*#__PURE__*/_jsxs(ButtonMultiClick, _objectSpread(_objectSpread({
    title: "\u304A\u6C17\u306B\u5165\u308A"
  }, buttonProps), {}, {
    favBtn: true,
    withIcon: true,
    favBtnWithLabel: !!text,
    className: className,
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx("span", {
      className: classnames(styles.icon, {
        [styles.favoriteOn]: favoriteOn
      }),
      children: /*#__PURE__*/_jsx(IconFav, {})
    }), text && /*#__PURE__*/_jsx("span", {
      className: styles.text,
      children: text
    })]
  }));
}